import { render, staticRenderFns } from "./chart-bar.vue?vue&type=template&id=3c08be45"
import script from "./chart-bar.vue?vue&type=script&lang=js"
export * from "./chart-bar.vue?vue&type=script&lang=js"
import style0 from "./chart-bar.vue?vue&type=style&index=0&id=3c08be45&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports